import { Redirect } from 'expo-router'

export default function MyFirstGameEmbeddedRedirect() {
  return <Redirect href="/game/my-first-game" />
}
